import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";

function useGetTab(selected) {
  const location = useLocation();
  let url = location.pathname;
  const getTab = useMemo(() => {
    if (url == "/inventory/admin/dashboard" || selected == "dashboard") {
      return "dashboard";
    } else if (url == "/inventory/admin/property" || selected == "property") {
      return "property";
    } else if (url == "/inventory/admin/outgoing" || selected == "outgoing") {
      return "outgoing";
    } else if (url == "/inventory/admin/inventory" || selected == "inventory") {
      return "inventory";
    } else if (url == "/inventory/admin/summary" || selected == "summary") {
      return "summary";
    } else if (url == "/inventory/admin/report" || selected == "report") {
      return "report";
    } else if (
      url == "/inventory/admin/purchase-order" ||
      selected == "purchase"
    ) {
      return "purchase";
    } else if (
      url == "/inventory/admin/purchase-order/finalized" ||
      selected == "final"
    ) {
      return "final";
    } else if (
      url == "/inventory/admin/purchase-order/returned=purcahaseorders" ||
      selected == "returnedorders"
    ) {
      return "returnedorders";
    } else if (url == "/inventory/admin/bills" || selected == "bills") {
      return "bills";
    } else if (
      url == "/inventory/admin/return-bills" ||
      selected == "return-bills"
    ) {
      return "return-bills";
    } else if (
      url == "/inventory/admin/bank-accounts" ||
      selected == "bank-accounts"
    ) {
      return "bank-accounts";
    } else if (
      url == "/inventory/admin/cash-in-hand" ||
      selected == "cash-in-hand"
    ) {
      return "cash-in-hand";
    } else if (
      url == "/inventory/admin/company-profile" ||
      selected == "company-profile"
    ) {
      return "company-profile";
    } else if (
      url == "/inventory/admin/sale-returns" ||
      selected == "sale-returns"
    ) {
      return "sale-returns";
    } else if (url == "/inventory/admin/ledgers" || selected == "ledgers") {
      return "ledgers";
    } else if (url == "/inventory/admin/vendors" || selected == "vendors") {
      return "vendors";
    } else if (
      url == "/inventory/admin/quotations" ||
      selected == "quotations"
    ) {
      return "quotations";
    } else if (
      url == "/inventory/admin/daily-book" ||
      selected == "daily-book"
    ) {
      return "daily-book";
    } else if (
      url == "/inventory/admin/expired-items" ||
      selected == "expired-items"
    ) {
      return "expired-items";
    } else if (url == "/inventory/admin/invoices" || selected == "invoices") {
      return "invoices";
    } else if (url == "/inventory/admin/fast-cash" || selected == "fast-cash") {
      return "fast-cash";
    } else if (
      url == "/inventory/admin/employee-salary" ||
      selected == "employee-salary"
    ) {
      return "employee-salary";
    } else if (
      url == "/inventory/admin/warehouse-bills" ||
      selected == "warehouse-bills"
    ) {
      return "warehouse-bills";
    } else if (url == "/inventory/admin/location" || selected == "location") {
      return "location";
    } else if (url == "/inventory/admin/store" || selected == "store") {
      return "store";
    } else if (url == "/inventory/admin/vouchers" || selected == "vouchers") {
      return "vouchers";
    } else if (
      url == "/inventory/admin/warehouses" ||
      selected == "warehouses"
    ) {
      return "warehouses";
    } else if (
      url == "/inventory/admin/vehicles-daily-sheet" ||
      selected == "vehicles-daily-sheet"
    ) {
      return "vehicles-daily-sheet";
    } else if (url == "/inventory/admin/vehicles" || selected == "vehicles") {
      return "vehicles";
    } else if (
      url == "/inventory/admin/employee-route" ||
      selected == "employee-route"
    ) {
      return "employee-route";
    } else if (url == "/inventory/admin/payment" || selected == "payment") {
      return "payment";
    } else if (
      url == "/inventory/admin/user-details" ||
      selected == "user-details"
    ) {
      return "user-details";
    } else if (
      url == "/inventory/admin/notifications" ||
      selected == "notifications"
    ) {
      return "notifications";
    } else if (
      url == "/inventory/admin/barcode-prints" ||
      selected == "barcode-prints"
    ) {
      return "barcode-prints";
    } else {
      return "";
    }
  }, [url, selected]);

  return getTab;
}

export default useGetTab;
